import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  YourVendors: [],
  YourVendorsPagination: null,
  findVendorsPagination: null,
  findVendor: [],
  findVendorsPaginationByCat: null,
  findVendorByCat: [],
  SubContacts: [],
  SubContactsPagination: null,
};

const VendorReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_NEW_VENDOR:
      let updatedYourVendorList = [...state.YourVendors];
      updatedYourVendorList.push(action.payload);
      state = {...state, YourVendors: updatedYourVendorList};
      break;

    case ActionTypes.GET_YOUR_VENDORS:
      let yourVendorCopy = [];
      yourVendorCopy = [...state.YourVendors, ...action.payload?.data];
      state = {
        ...state,
        YourVendors: yourVendorCopy,
        YourVendorsPagination: action.payload,
      };
      break;
      case ActionTypes.GET_VENDOR_DETAILS:
        state = {  ...state, VendorDetails : action.payload};
        break;

    case ActionTypes.CLEAR_YOUR_VENDORS:
      state = {...state, YourVendorsPagination: null, YourVendors: []};
      break;

    case ActionTypes.GET_FIND_VENDORS:
      let findVendorCopy = [];
      findVendorCopy = [...state.findVendor, ...action.payload?.data];
      state = {
        ...state,
        findVendor: findVendorCopy,
        findVendorsPagination: action.payload,
      };
      break;

    case ActionTypes.GET_FIND_VENDORS_BY_CATEGORY:
      let findVendorCatCopy = [];
      findVendorCatCopy = [...state.findVendorByCat, ...action.payload?.data];
      state = {
        ...state,
        findVendorByCat: findVendorCatCopy,
        findVendorsPaginationByCat: action.payload,
      };
      break;

    case ActionTypes.CLEAR_FIND_VENDORS:
      state = {...state, findVendorsPagination: null, findVendor: []};
      break;

    case ActionTypes.CLEAR_FIND_VENDORS_BY_CATEGORY:
      state = {...state, findVendorsPaginationByCat: null, findVendorByCat: []};
      break;

    case ActionTypes.REMOVE_VENDOR_FROM_EVENT:
      let updatedList = [...state.YourVendors];
      let index_to_be_deleted = updatedList.findIndex(
        item => item?.id == action?.payload,
      );
      updatedList.splice(index_to_be_deleted, 1);
      state = {...state, YourVendors: updatedList};
      break;

    case ActionTypes.GET_SUB_CONTACTS:
      let subContactCopy = [];
      subContactCopy = [...state.SubContacts, ...action.payload?.data];
      state = {
        ...state,
        SubContacts: subContactCopy,
        SubContactsPagination: action.payload,
      };
      break;

    case ActionTypes.CLEAR_SUB_CONTACTS:
      state = {...state, SubContactsPagination: null, SubContacts: []};
      break;

    case ActionTypes.UPDATE_SUB_CONTACTS:
      let Sub_Contacts_List_Copy = [...state.SubContacts];
      Sub_Contacts_List_Copy.unshift(action.payload);
      state = {
        ...state,
        SubContacts: Sub_Contacts_List_Copy,
      };
      break;

      case ActionTypes.REMOVE_SUB_VENDOR:
  return {
    ...state,
    SubContacts: state.SubContacts.filter(
      (item) => item.id !== action.payload
    ),
  };

    default:
      break;
  }
  return state;
};

export default VendorReducer;
